var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTwitterX = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "145 64.89 270 270.23"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m178.57 127.15 111.7-127.15h-26.46l-97.03 110.38-77.44-110.38h-89.34l117.13 166.93-117.13 133.32h26.46l102.4-116.59 81.8 116.59h89.34m-263.99-280.71h40.65l187.13 262.13h-40.66",
  fillRule: "nonzero",
  transform: "matrix(.9 0 0 .9 145 64.8875)"
})));
export default SvgTwitterX;